import { Box, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { elStyle } from '../common/ContractTableHandlerCss';
import { CONTRACT_SCREEN_MANAGEMENT } from '@/common/constant/NormalContractManagementConstant';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function ChoosePaymentConfirm({ paymentMethod, setPaymentMethod }) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const radioBtn = [
        {
            label: trI18n('LABEL-BANK-TRANSFER'),
            value: CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.BANK_TRANSFER,
            defaultChecked: paymentMethod == CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.BANK_TRANSFER,
            style: { paddingRight: '48px' }
        }
    ];

    const handleChoosePayment = e => {
        const val = e.target.value;
        setPaymentMethod(val);
    };

    return (
        <Box display="flex" flexDirection="column">
            <Box component="p" {...elStyle.total_price_label}>
                {trI18n('LABEL-TITLE-PAYMENT-METHOD')}
            </Box>
            <RadioGroup row aria-label="" name="radio-buttons-group">
                <Box
                    display="flex"
                    p="0 16px 20px 12px"
                    borderBottom="#E3E5E8 solid 1px"
                    width="100%"
                >
                    {radioBtn.map(item => (
                        <FormControlLabel
                            key={item.label}
                            className="tag-item custom-radio"
                            value={item.value}
                            control={<Radio checked={item.defaultChecked} />}
                            label={item.label}
                            style={item?.style}
                            onClick={e => handleChoosePayment(e)}
                        />
                    ))}
                </Box>
            </RadioGroup>
        </Box>
    );
}

export default ChoosePaymentConfirm;
